<div class="x">
  <div class="slant slant-right"></div>
  <div class="slant slant-left"></div>
</div>